// extracted by mini-css-extract-plugin
module.exports = {"sectionFieldItem":"SectionFieldItem_sectionFieldItem__21nZl","label":"SectionFieldItem_label__3Qn7y","value":"SectionFieldItem_value__2K1Hc"};